export const DEBUG_SET_SHOW_TRANSLATION_KEYS = 'DEBUG_SET_SHOW_TRANSLATION_KEYS';
